module.exports = __webpack_public_path__ + "static/media/MH.969819c2.svg";